export type SyncAuthBody = {
	sub: string;
	email: string;
	firstName: string;
	lastName: string;
	picture: string;
};

export type SyncAuthUser = {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	picture: string | null;
	auth0Sub: string;
	active: boolean;
	lastLoginAt: string | null;
	createdAt: string;
	updatedAt: string;
};

export type SyncAuthParams = {
	body: SyncAuthBody;
	getToken: () => Promise<string>;
};

export const syncAuth = async (params: SyncAuthParams): Promise<[SyncAuthUser | null, string | null]> => {
	const { body, getToken } = params;

	try {
		let headers: Record<string, string> = { 'Content-Type': 'application/json' };
		try {
			const token = await getToken();
			headers = { ...headers, Authorization: `Bearer ${token}` };
		} catch (_tokenError) {
			// Token not available — endpoint doesn't require it
		}

		const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/sync`, {
			method: 'POST',
			headers,
			body: JSON.stringify(body)
		});

		if (response.ok) {
			const data: SyncAuthUser = await response.json();
			return [data, null];
		}

		const errorText = await response.text();
		return [null, `Auth sync failed: ${response.status} ${errorText}`];
	} catch (error) {
		console.warn('Error syncing auth', error);
		return [null, `Error syncing auth: ${(error as Error).message}`];
	}
};
